/**
 * Colour finishes rendered on the Finishes page.
 *
 * Each swatch below points to a cropped PNG/WebP image extracted directly
 * from the Eurosteel and Dulux Powdercoat PDFs so the textures on metallic,
 * pearl, and Protexture finishes are visible.
 */

export const EUROSTEEL_SIGNATURE = [
  { name: "1#", image: "/finishes/eurosteel/eurosteel-1.webp" },
  { name: "3#", image: "/finishes/eurosteel/eurosteel-3.webp" },
  { name: "4#", image: "/finishes/eurosteel/eurosteel-4.webp" },
  { name: "5#", image: "/finishes/eurosteel/eurosteel-5.webp" },
  { name: "6#", image: "/finishes/eurosteel/eurosteel-6.webp" },
  { name: "7#", image: "/finishes/eurosteel/eurosteel-7.webp" },
  { name: "8#", image: "/finishes/eurosteel/eurosteel-8.webp" },
  { name: "9#", image: "/finishes/eurosteel/eurosteel-9.webp" },
  { name: "10#", image: "/finishes/eurosteel/eurosteel-10.webp" },
  { name: "11#", image: "/finishes/eurosteel/eurosteel-11.webp" },
  { name: "12#", image: "/finishes/eurosteel/eurosteel-12.webp" },
];

export const DULUX_POWDERCOAT = [
  {
    category: "Whites & Neutrals",
    colours: [
      { name: "Appliance White", image: "/finishes/dulux/appliance-white-whites-neutrals.webp" },
      { name: "Titania", image: "/finishes/dulux/titania-whites-neutrals.webp" },
      { name: "Canvas Cloth", image: "/finishes/dulux/canvas-cloth-whites-neutrals.webp" },
      { name: "Bone White", image: "/finishes/dulux/bone-white-whites-neutrals.webp" },
      { name: "Arctic White", image: "/finishes/dulux/arctic-white-whites-neutrals.webp" },
      { name: "Off White", image: "/finishes/dulux/off-white-whites-neutrals.webp" },
      { name: "Pure White", image: "/finishes/dulux/pure-white-whites-neutrals.webp" },
      { name: "Okarito", image: "/finishes/dulux/okarito-whites-neutrals.webp" },
    ],
  },
  {
    category: "Greys",
    colours: [
      { name: "O’Keefe Grey", image: "/finishes/dulux/o-keefe-grey-greys.webp" },
      { name: "Kauri", image: "/finishes/dulux/kauri-greys.webp" },
      { name: "Gull Grey", image: "/finishes/dulux/gull-grey-greys.webp" },
      { name: "Thunder Grey", image: "/finishes/dulux/thunder-grey-greys.webp" },
      { name: "Gravel", image: "/finishes/dulux/gravel-greys.webp" },
      { name: "Sandstone Grey", image: "/finishes/dulux/sandstone-grey-greys.webp" },
      { name: "Mid Grey", image: "/finishes/dulux/mid-grey-greys.webp" },
      { name: "Flint", image: "/finishes/dulux/flint-greys.webp" },
      { name: "Grey Friars", image: "/finishes/dulux/grey-friars-greys.webp" },
      { name: "Ghost Grey", image: "/finishes/dulux/ghost-grey-greys.webp" },
      { name: "Windsor Grey", image: "/finishes/dulux/windsor-grey-greys.webp" },
      { name: "O'Keefe Grey", image: "/finishes/dulux/okeefe-grey-greys.webp" },
      { name: "Mid Bronze", image: "/finishes/dulux/mid-bronze-greys.webp" },
    ],
  },
  {
    category: "Blacks",
    colours: [
      { name: "Black", image: "/finishes/dulux/black-blacks.webp" },
      { name: "Charcoal", image: "/finishes/dulux/charcoal-blacks.webp" },
    ],
  },
  {
    category: "Browns & Beiges",
    colours: [
      { name: "Magnolia", image: "/finishes/dulux/magnolia-browns-beiges.webp" },
      { name: "Woodwind", image: "/finishes/dulux/woodwind-browns-beiges.webp" },
      { name: "Rivergum Beige", image: "/finishes/dulux/rivergum-beige-browns-beiges.webp" },
      { name: "Almond", image: "/finishes/dulux/almond-browns-beiges.webp" },
      { name: "Desert Sand", image: "/finishes/dulux/desert-sand-browns-beiges.webp" },
      { name: "Bronco", image: "/finishes/dulux/bronco-browns-beiges.webp" },
      { name: "Lignite", image: "/finishes/dulux/lignite-browns-beiges.webp" },
      { name: "Ironsand", image: "/finishes/dulux/ironsand-browns-beiges.webp" },
      { name: "Anotec®", image: "/finishes/dulux/anotec-browns-beiges.webp" },
    ],
  },
  {
    category: "Blues",
    colours: [
      { name: "New Denim Blue", image: "/finishes/dulux/new-denim-blue-blues.webp" },
      { name: "Wedgewood", image: "/finishes/dulux/wedgewood-blues.webp" },
      { name: "Storm Blue", image: "/finishes/dulux/storm-blue-blues.webp" },
      { name: "Slate Blue", image: "/finishes/dulux/slate-blue-blues.webp" },
      { name: "Wizard", image: "/finishes/dulux/wizard-blues.webp" },
      { name: "Navy", image: "/finishes/dulux/navy-blues.webp" },
    ],
  },
  {
    category: "Greens",
    colours: [
      { name: "Lichen", image: "/finishes/dulux/lichen-greens.webp" },
      { name: "Olive", image: "/finishes/dulux/olive-greens.webp" },
      { name: "Flaxpod®", image: "/finishes/dulux/flaxpod-greens.webp" },
      { name: "Mist Green", image: "/finishes/dulux/mist-green-greens.webp" },
      { name: "Karaka", image: "/finishes/dulux/karaka-greens.webp" },
      { name: "Rangoon Green", image: "/finishes/dulux/rangoon-green-greens.webp" },
      { name: "Bond Rivergum", image: "/finishes/dulux/bond-rivergum-greens.webp" },
      { name: "Permanent Green", image: "/finishes/dulux/permanent-green-greens.webp" },
    ],
  },
  {
    category: "Reds",
    colours: [
      { name: "Pioneer Red", image: "/finishes/dulux/pioneer-red-reds.webp" },
      { name: "Scoria", image: "/finishes/dulux/scoria-reds.webp" },
      { name: "Cola Red", image: "/finishes/dulux/cola-red-reds.webp" },
    ],
  },
  {
    category: "Pearlescent & Metallic",
    colours: [
      { name: "Metro Warm White Pearl Kinetic®", image: "/finishes/dulux/metro-warm-white-pearl-kinetic-pearlescent-metallic.webp" },
      { name: "Metro Silver Pearl Kinetic®", image: "/finishes/dulux/metro-silver-pearl-kinetic-pearlescent-metallic.webp" },
      { name: "Palladium Silver Kinetic®", image: "/finishes/dulux/palladium-silver-kinetic-pearlescent-metallic.webp" },
      { name: "Warm White Pearl Kinetic®", image: "/finishes/dulux/warm-white-pearl-kinetic-pearlescent-metallic.webp" },
      { name: "Silver Star Kinetic®", image: "/finishes/dulux/silver-star-kinetic-pearlescent-metallic.webp" },
      { name: "Window Bronze Kinetic®", image: "/finishes/dulux/window-bronze-kinetic-pearlescent-metallic.webp" },
      { name: "Silver Pearl Kinetic®", image: "/finishes/dulux/silver-pearl-kinetic-pearlescent-metallic.webp" },
      { name: "Metro Electric Cow Kinetic®", image: "/finishes/dulux/metro-electric-cow-kinetic-pearlescent-metallic.webp" },
      { name: "Mineral Brown Kinetic®", image: "/finishes/dulux/mineral-brown-kinetic-pearlescent-metallic.webp" },
      { name: "Metro Coal Dust Kinetic®", image: "/finishes/dulux/metro-coal-dust-kinetic-pearlescent-metallic.webp" },
      { name: "Prosecco Pearl", image: "/finishes/dulux/prosecco-pearl-pearlescent-metallic.webp" },
      { name: "Gunmetal Metallic Kinetic®", image: "/finishes/dulux/gunmetal-metallic-kinetic-pearlescent-metallic.webp" },
      { name: "Bright Gold Pearl", image: "/finishes/dulux/bright-gold-pearl-pearlescent-metallic.webp" },
      { name: "Copper Pearl", image: "/finishes/dulux/copper-pearl-pearlescent-metallic.webp" },
      { name: "Bronze Copper Pearl", image: "/finishes/dulux/bronze-copper-pearl-pearlescent-metallic.webp" },
    ],
  },
  {
    category: "Textured (Protexture)",
    colours: [
      { name: "Metro Silver Pearl", image: "/finishes/dulux/metro-silver-pearl-textured-protexture.webp" },
      { name: "Sandstone Grey", image: "/finishes/dulux/sandstone-grey-textured-protexture.webp" },
      { name: "Warm White Pearl", image: "/finishes/dulux/warm-white-pearl-textured-protexture.webp" },
      { name: "Arctic White", image: "/finishes/dulux/arctic-white-textured-protexture.webp" },
      { name: "Windsor Grey", image: "/finishes/dulux/windsor-grey-textured-protexture.webp" },
      { name: "Black", image: "/finishes/dulux/black-textured-protexture.webp" },
      { name: "Appliance White", image: "/finishes/dulux/appliance-white-textured-protexture.webp" },
      { name: "Grey Friars", image: "/finishes/dulux/grey-friars-textured-protexture.webp" },
      { name: "Charcoal", image: "/finishes/dulux/charcoal-textured-protexture.webp" },
      { name: "Flaxpod®", image: "/finishes/dulux/flaxpod-textured-protexture.webp" },
      { name: "Titania", image: "/finishes/dulux/titania-textured-protexture.webp" },
      { name: "Ironsand", image: "/finishes/dulux/ironsand-textured-protexture.webp" },
    ],
  },
];
